import script from "./QuestionnairesPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./QuestionnairesPage.vue?vue&type=script&setup=true&lang=ts"

import "./QuestionnairesPage.vue?vue&type=style&index=0&id=4baf701e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4baf701e"]])

export default __exports__